import { request } from './http';

/**
 * 认证相关 API
 */

export interface LoginResult {
  accessToken: string;
  refreshToken: string;
  expiresIn: number;
  user: {
    userId: string;
    accountId: number;
    nickname: string;
    avatar: string | null;
    userType: number;
    realnameStatus: number;
    tenantId: number;
  };
}

export interface RegisterParams {
  phone: string;
  code: string;
  password: string;
  nickname: string;
  deviceId?: string;
  deviceName?: string;
  deviceType?: 'pc' | 'ios' | 'android' | 'web';
}

export interface LoginParams {
  loginType: 'phone' | 'accountId';
  account: string;
  credentialType: 'password' | 'code';
  credential: string;
  deviceId?: string;
  deviceName?: string;
  deviceType?: 'pc' | 'ios' | 'android' | 'web';
}

export interface QrCodeResult {
  ticket: string;
  qrContent: string;
  expiresAt: number;
}

export type QrStatus = 'waiting' | 'scanned' | 'confirmed' | 'expired';

export interface QrStatusResult {
  status: QrStatus;
  tokens?: {
    accessToken: string;
    refreshToken: string;
    expiresIn: number;
  };
}

/**
 * 发送短信验证码
 */
export function sendSmsCode(phone: string, scene = 'register'): Promise<void> {
  return request({
    method: 'POST',
    url: '/sms/send',
    data: { phone, scene },
  });
}

/**
 * 注册
 */
export function register(params: RegisterParams): Promise<LoginResult> {
  return request({
    method: 'POST',
    url: '/auth/register',
    data: params,
  });
}

/**
 * 登录
 */
export function login(params: LoginParams): Promise<LoginResult> {
  return request({
    method: 'POST',
    url: '/auth/login',
    data: params,
  });
}

/**
 * 刷新 Token
 */
export function refreshToken(refreshToken: string): Promise<{
  accessToken: string;
  refreshToken: string;
  expiresIn: number;
}> {
  return request({
    method: 'POST',
    url: '/auth/refresh-token',
    data: { refreshToken },
  });
}

/**
 * 退出登录
 */
export function logout(): Promise<{ message: string }> {
  return request({
    method: 'POST',
    url: '/auth/logout',
  });
}

/**
 * 生成扫码登录二维码
 */
export function generateQrCode(): Promise<QrCodeResult> {
  return request({
    method: 'GET',
    url: '/auth/qr-code',
  });
}

/**
 * 轮询二维码状态
 */
export function pollQrStatus(ticket: string): Promise<QrStatusResult> {
  return request({
    method: 'GET',
    url: '/auth/qr-code/status',
    params: { ticket },
  });
}

/**
 * 确认扫码登录（移动端）
 */
export function confirmQrLogin(ticket: string): Promise<{ message: string }> {
  return request({
    method: 'POST',
    url: '/auth/qr-code/confirm',
    data: { ticket },
  });
}
